module.exports = __webpack_public_path__ + "static/media/deck.20f08a16.jpg";